import Emojify from "~/components/shared/Emojify";
import parseEmoji from "~/lib/parseEmoji";
import { CommandStep, isMatrixCommandStep } from "~/lib/pipeline";

export default function CommandStepLabel(step: CommandStep) {
  if (!step.label && step.commandScript) {
    return (
      <span className="font-mono text-[90%]" title={step.commandScript}>
        {step.commandScript}
      </span>
    );
  }

  if (isMatrixCommandStep(step)) {
    const html = parseEmoji(step.label).replace(/{{\s?matrix(?:\.(.*?))?\s?}}/g, (match, key) => {
      return `<span class="font-mono text-[90%]">{${key || "matrix"}}</span>`;
    });

    return <span dangerouslySetInnerHTML={{ __html: html }} />;
  }

  // Suppress the default title tooltip since the canvas node already has a hover card
  return <Emojify text={step.label} title="" />;
}
